<app-side-menu>
  <div class="external-providers-content">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <h1 class="page-title">
                <i class="fas fa-handshake me-3"></i>
                Prestadores de Serviço Externo (B2B)
              </h1>
              <p class="page-subtitle">
                Gerencie os prestadores de serviço externos utilizados nos seus contratos e operações.
              </p>
            </div>
            <app-button
              *appHasPermission="'ExternalProviders.Create'"
              text="Novo Prestador"
              color="var(--success-color)"
              (buttonClick)="newProvider()"
              className="new-provider-btn">
              <i class="fas fa-plus me-2"></i>
            </app-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Conteúdo Principal -->
    <div class="row">
      <div class="col-12">
        <div class="external-providers-card">
          <!-- Loading -->

          <!-- Tabela (sempre visível para manter a busca acessível) -->
          <div class="external-providers-table">
            <div class="table-header" style="display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:8px;">
              <div>
                <h3 class="table-title">
                  <i class="fas fa-list me-2"></i>
                  Lista de Prestadores
                </h3>
                <p class="mb-0 text-muted">
                  Total de {{ totalItems || providers.length }} prestador{{ (totalItems || providers.length) !== 1 ? 'es' : '' }}
                </p>
              </div>
            </div>

            <div class="table-content">
              <app-table
                [title]="'Prestadores de Serviço Externo'"
                [data]="providers"
                [columns]="columns"
                [loading]="isLoading"
                [clickable]="true"
                [actions]="actions"
                [totalItemsFromBackend]="totalItems"
                [enableSorting]="true"
                (searchChange)="onSearchChange($event)"
                (rowClick)="view($event)"
                (actionClick)="onActionClick($event)"
                (pageChange)="onPageChange($event)"
                (pageSizeChange)="onPageSizeChange($event)"
                (sortChange)="onSortChange($event)">
              <app-button
                table-header-action
                text="Exportar Excel"
                color="var(--success-color)"
                height="36px"
                [disabled]="providers.length === 0"
                (buttonClick)="exportExcel()">
                <i class="fas fa-file-excel me-2"></i>
              </app-button>
            </app-table>
            </div>

            <!-- Estado vazio dentro da tabela -->
            <div *ngIf="!isLoading && providers.length === 0" class="empty-state">
              <i class="fas fa-handshake"></i>
              <h3>Nenhum prestador encontrado</h3>
              <p>Cadastre seu primeiro prestador de serviço externo para usar em contratos e operações.</p>
              <app-button
                *appHasPermission="'ExternalProviders.Create'"
                text="Cadastrar Primeiro Prestador"
                color="var(--primary-color)"
                (buttonClick)="newProvider()"
                className="btn-primary">
                <i class="fas fa-plus me-2"></i>
              </app-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>


